import { render } from "./compliance_management.html?vue&type=template&id=5feaf5fe&scoped=true&external"
import script from "./compliance_management?vue&type=script&lang=js&external"
export * from "./compliance_management?vue&type=script&lang=js&external"

import "./ComplianceManagement.vue?vue&type=style&index=0&id=5feaf5fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5feaf5fe"]])

export default __exports__